import {
  Stethoscope,
  HeartPulse,
  Syringe,
  Cross,
  Microscope,
  ScanLine,
  Pill,
  Scissors,
  Bath,
  Sparkles,
  Hotel,
  Dog,
  Footprints,
  House,
  Clock3,
  ShieldCheck,
  Camera,
  Trees,
  Snowflake,
  Car,
  ShoppingBag,
  Package,
  Bone,
  Bird,
  GraduationCap,
  Users,
  Laptop,
  Fence,
  Droplets,
  Lightbulb,
  Dumbbell,
  PawPrint,
} from 'lucide-react';

export const PET_AMENITIES_CONFIG = {
  atencion_veterinaria: {
    label: 'Atención veterinaria',
    items: [
      { id: 'consulta_veterinaria', label: 'Consulta veterinaria', icon: Stethoscope },
      { id: 'urgencias', label: 'Urgencias', icon: HeartPulse },
      { id: 'atencion_24_horas', label: 'Atención 24 horas', icon: Clock3 },
      { id: 'vacunacion', label: 'Vacunación', icon: Syringe },
      { id: 'desparasitacion', label: 'Desparasitación', icon: Pill },
      { id: 'cirugia', label: 'Cirugía', icon: Cross },
      { id: 'hospitalizacion', label: 'Hospitalización', icon: Hotel },
      { id: 'laboratorio', label: 'Laboratorio', icon: Microscope },
      { id: 'radiografias', label: 'Radiografías', icon: ScanLine },
      { id: 'ecografias', label: 'Ecografías', icon: ScanLine },
      { id: 'odontologia', label: 'Odontología', icon: Cross },
      { id: 'farmacia_veterinaria', label: 'Farmacia veterinaria', icon: Pill },
      { id: 'teleconsulta', label: 'Teleconsulta', icon: Laptop },
      { id: 'atencion_domicilio', label: 'Atención a domicilio', icon: House },
    ],
  },

  peluqueria_bienestar: {
    label: 'Peluquería y bienestar',
    items: [
      { id: 'peluqueria', label: 'Peluquería', icon: Scissors },
      { id: 'bano', label: 'Baño', icon: Bath },
      { id: 'corte_pelo', label: 'Corte de pelo', icon: Scissors },
      { id: 'corte_unas', label: 'Corte de uñas', icon: Scissors },
      { id: 'limpieza_oidos', label: 'Limpieza de oídos', icon: Sparkles },
      { id: 'deslanado', label: 'Deslanado', icon: Sparkles },
      { id: 'spa', label: 'Spa para mascotas', icon: Sparkles },
    ],
  },

  hospedaje_cuidado: {
    label: 'Hospedaje y cuidado',
    items: [
      { id: 'hotel_mascotas', label: 'Hotel para mascotas', icon: Hotel },
      { id: 'guarderia', label: 'Guardería', icon: Dog },
      { id: 'paseos', label: 'Paseos', icon: Footprints },
      { id: 'cuidado_domicilio', label: 'Cuidado a domicilio', icon: House },
      { id: 'supervision_24_horas', label: 'Supervisión 24 horas', icon: Clock3 },
      { id: 'habitacion_individual', label: 'Habitación individual', icon: Hotel },
      { id: 'transporte_mascotas', label: 'Transporte de mascotas', icon: Car },
      { id: 'retiro_entrega', label: 'Retiro y entrega', icon: Car },
    ],
  },

  adiestramiento: {
    label: 'Adiestramiento',
    items: [
      { id: 'adiestramiento', label: 'Adiestramiento', icon: GraduationCap },
      { id: 'adiestramiento_individual', label: 'Entrenamiento individual', icon: Dog },
      { id: 'adiestramiento_grupal', label: 'Entrenamiento grupal', icon: Users },
      { id: 'adiestramiento_domicilio', label: 'Entrenamiento a domicilio', icon: House },
      { id: 'adiestramiento_online', label: 'Entrenamiento online', icon: Laptop },
      { id: 'cursos_cachorros', label: 'Cursos para cachorros', icon: PawPrint },
      { id: 'obediencia', label: 'Obediencia', icon: GraduationCap },
      { id: 'modificacion_conducta', label: 'Modificación de conducta', icon: HeartPulse },
      { id: 'agility', label: 'Agility', icon: Dumbbell },
    ],
  },

  tienda_alimentacion: {
    label: 'Tienda y alimentación',
    items: [
      { id: 'alimento_perros', label: 'Alimento para perros', icon: Dog },
      { id: 'alimento_gatos', label: 'Alimento para gatos', icon: PawPrint },
      { id: 'productos_aves', label: 'Productos para aves', icon: Bird },
      { id: 'alimento_humedo', label: 'Alimento húmedo', icon: Package },
      { id: 'snacks', label: 'Snacks', icon: Bone },
      { id: 'accesorios', label: 'Accesorios', icon: ShoppingBag },
      { id: 'juguetes', label: 'Juguetes', icon: Bone },
      { id: 'higiene', label: 'Higiene', icon: Sparkles },
      { id: 'delivery', label: 'Despacho a domicilio', icon: Car },
    ],
  },

  instalaciones: {
    label: 'Instalaciones y seguridad',
    items: [
      { id: 'camaras_seguridad', label: 'Cámaras de seguridad', icon: Camera },
      { id: 'protocolos_seguridad', label: 'Protocolos de seguridad', icon: ShieldCheck },
      { id: 'webcam', label: 'Webcam', icon: Camera },
      { id: 'areas_verdes', label: 'Áreas verdes', icon: Trees },
      { id: 'patio_exterior', label: 'Patio exterior', icon: Trees },
      { id: 'espacios_climatizados', label: 'Espacios climatizados', icon: Snowflake },
      { id: 'estacionamiento', label: 'Estacionamiento', icon: Car },
      { id: 'recinto_cerrado', label: 'Recinto cerrado', icon: Fence },
      { id: 'agua_disponible', label: 'Agua disponible', icon: Droplets },
      { id: 'iluminacion', label: 'Iluminación', icon: Lightbulb },
      { id: 'juegos', label: 'Zona de juegos', icon: Dumbbell },
    ],
  },
};

export const PET_AMENITY_CATEGORIES = Object.values(PET_AMENITIES_CONFIG).map(
  category => ({
    name: category.label,
    items: category.items.map(item => item.id),
  })
);

export const PET_AMENITY_ITEMS = Object.values(PET_AMENITIES_CONFIG)
  .flatMap(category => category.items);

export const PET_AMENITY_ICON_MAP = PET_AMENITY_ITEMS.reduce(
  (result, item) => {
    result[item.id] = item.icon;
    return result;
  },
  {}
);

export const PET_AMENITY_LABEL_MAP = PET_AMENITY_ITEMS.reduce(
  (result, item) => {
    result[item.id] = item.label;
    return result;
  },
  {}
);

export const formatPetAmenity = amenity =>
  PET_AMENITY_LABEL_MAP[amenity] ||
  String(amenity || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase());
